import { create } from 'zustand';
import { Classroom } from '../models/classroom';
import { Student } from '../models/student';
import { Dashboard } from '../models/dashboard';

interface StudentState {
    student: Student | null;
    setStudent: (student: Student) => void;
    classrooms: Record<number, Classroom> | null;
    setClassrooms: (data: Record<number, Classroom>) => void;
    dashboard: Dashboard | null;
    setDashboard: (data: Dashboard) => void;
}

export const useStudentStore = create<StudentState>((set) => ({
    student: null,
    setStudent: (data) => set({ student: data }),
    classrooms: null,
    setClassrooms: (data) => set({ classrooms: data }),
    dashboard: null,
    setDashboard: (data) => set({ dashboard: data })
}));
